<pagination-tag>
    <div class="ui pagination menu">
        <a class="icon item" onclick="{(e)=> select(this, e, 1)}"><i class="angle double left icon"></i></a>
        <a class="icon item" onclick="{(e)=> select(this, e, prev)}"><i class="angle left icon"></i></a>
        <a each="{ item in pager }" class="item{ item.curr ? ' active' : '' }" onclick="{(e)=> select(this, e, item.page)}">{ item.page }</a>
        <a class="icon item" onclick="{(e)=> select(this, e, next)}"><i class="angle right icon"></i></a>
        <a class="icon item" onclick="{(e)=> select(this, e, last)}"><i class="angle double right icon"></i></a>
    </div>
    <p class="pager_txt">全{total}件 {page} ／ {last}ページ</p>
    <script>
        export default {
            onBeforeMount(props, state) {
                this.page = 1;
                this.total = 1;
                this.last = 1;
                this.prev = 1;
                this.next = 1;
                this.pager = [];
                this.setPager(props.pager);
            },
            onBeforeUpdate(props, state) {
                this.setPager(props.pager);
            },
            setPager(pager) {
                this.page = (typeof pager.page !== 'undefined') ? pager.page: 1;
                this.total = (typeof pager.total !== 'undefined') ? pager.total: 1;
                this.last = (typeof pager.last !== 'undefined') ? pager.last: 1;
                this.prev = (typeof pager.prev !== 'undefined') ? pager.prev: 1;
                this.next = (typeof pager.next !== 'undefined') ? pager.next: 1;

                let start = this.page  - 5
                  , end = this.page  + 5
                  , page = 0
                  , list = [];

                if (0 >= start) {
                    end = end + start * -1;
                    start = 1;
                }
                if (this.last <= end) {
                    end = this.last;
                }

                for (page=start; page < this.page; page++) {
                    list.push({ page:page, curr:false });
                }
                list.push({ page:this.page, curr:true });

                for (page++; page <= end; page++) {
                    list.push({ page:page, curr:false });
                }
                this.pager = list;
            },
            select(parent, e, page) {
                if (typeof parent.props === 'undefined') {
                    return ;
                } else if (typeof parent.props.onpager === 'undefined') {
                    return ;
                }
                parent.props.onpager(e, page);
            }
        }
    </script>
</pagination-tag>
